module.exports = __webpack_public_path__ + "static/img/pc_map.b48c5cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pc_map.png
// module id = Ux50
// module chunks = 1